import React, {useCallback, useEffect, useState} from 'react';
import {withStyle} from 'baseui';
import {Col as Column, Grid, Row as Rows} from 'components/FlexBox/FlexBox';
import {useDrawerDispatch} from 'context/DrawerContext';
import Input from 'components/Input/Input';
import Checkbox from 'components/CheckBox/CheckBox';
import {Header, Heading, Wrapper} from 'components/Wrapper.style';
import {StyledCell, StyledHeadCell, StyledTable, TableWrapper,} from './Checkin.style';
import * as icons from 'assets/icons/category-icons';
import NoResult from 'components/NoResult/NoResult';
import {client} from "../../api/client";
import {BASE_API_URL} from "../../api/endpoint";


const Col = withStyle(Column, () => ({
    '@media only screen and (max-width: 767px)': {
        marginBottom: '20px',

        ':last-child': {
            marginBottom: 0,
        },
    },
}));

const Row = withStyle(Rows, () => ({
    '@media only screen and (min-width: 768px)': {
        alignItems: 'center',
    },
}));

export default function CheckinHistory() {
    const [search, setSearch] = useState('');
    const dispatch = useDrawerDispatch();
    const [checkedId, setCheckedId] = useState([]);
    const [checked, setChecked] = useState(false);
    const [data, setData] = useState([]);
    const openDrawer = useCallback(
        () => dispatch({type: 'OPEN_DRAWER', drawerComponent: 'USER_FORM'}),
        [dispatch]
    );

    async function fetchShop() {
        const his = await client.get(`${BASE_API_URL}/checkout`);
        if (his.status !== 200) {
            return
        }
        setData(his.data)
    }

    useEffect(() => {
        fetchShop();
    }, []);


    function handleSearch(event) {
        const value = event.currentTarget.value;
    }

    function onAllCheck(event) {
        if (event.target.checked) {
            const idx = data && data.map((current) => current.id);
            setCheckedId(idx);
        } else {
            setCheckedId([]);
        }
        setChecked(event.target.checked);
    }

    function handleCheckbox(event) {
        const {name} = event.currentTarget;
        if (!checkedId.includes(name)) {
            setCheckedId((prevState) => [...prevState, name]);
        } else {
            setCheckedId((prevState) => prevState.filter((id) => id !== name));
        }
    }

    const Icon = ({name}) => {
        const TagName = icons[name];
        return !!TagName ? <TagName/> : <p>Invalid icon {name}</p>;
    };

    return (
        <Grid fluid={true}>
            <Row>
                <Col md={12}>
                    <Header
                        style={{
                            marginBottom: 30,
                            boxShadow: '0 0 5px rgba(0, 0 ,0, 0.05)',
                        }}
                    >
                        <Col md={2}>
                            <Heading>Checkin history</Heading>
                        </Col>

                        <Col md={10}>
                            <Row>
                                <Col md={5} lg={6}>
                                    <Input
                                        value={search}
                                        placeholder="Ex: Search By Name"
                                        onChange={handleSearch}
                                        clearable
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Header>

                    <Wrapper style={{boxShadow: '0 0 5px rgba(0, 0 , 0, 0.05)'}}>
                        <TableWrapper>
                            <StyledTable
                                $gridTemplateColumns="minmax(70px, 70px) auto auto auto auto auto">
                                <StyledHeadCell>
                                    <Checkbox
                                        type="checkbox"
                                        value="checkAll"
                                        checked={checked}
                                        onChange={onAllCheck}
                                        overrides={{
                                            Checkmark: {
                                                style: {
                                                    borderTopWidth: '2px',
                                                    borderRightWidth: '2px',
                                                    borderBottomWidth: '2px',
                                                    borderLeftWidth: '2px',
                                                    borderTopLeftRadius: '4px',
                                                    borderTopRightRadius: '4px',
                                                    borderBottomRightRadius: '4px',
                                                    borderBottomLeftRadius: '4px',
                                                },
                                            },
                                        }}
                                    />
                                </StyledHeadCell>
                                <StyledHeadCell>Shop name</StyledHeadCell>
                                <StyledHeadCell>Full name</StyledHeadCell>
                                <StyledHeadCell>Type</StyledHeadCell>
                                <StyledHeadCell>Reason</StyledHeadCell>
                                <StyledHeadCell>Checkout at</StyledHeadCell>

                                {data ? (
                                    data.length ? (
                                        data
                                            .map((item, index) => (
                                                <React.Fragment key={index}>
                                                    <StyledCell>
                                                        <Checkbox
                                                            name={item.id}
                                                            checked={checkedId.includes(item.id)}
                                                            onChange={handleCheckbox}
                                                            overrides={{
                                                                Checkmark: {
                                                                    style: {
                                                                        borderTopWidth: '2px',
                                                                        borderRightWidth: '2px',
                                                                        borderBottomWidth: '2px',
                                                                        borderLeftWidth: '2px',
                                                                        borderTopLeftRadius: '4px',
                                                                        borderTopRightRadius: '4px',
                                                                        borderBottomRightRadius: '4px',
                                                                        borderBottomLeftRadius: '4px',
                                                                    },
                                                                },
                                                            }}
                                                        />
                                                    </StyledCell>
                                                    <StyledCell>{item.shop_name}</StyledCell>
                                                    <StyledCell>{item.full_name}</StyledCell>
                                                    <StyledCell>{item.type}</StyledCell>
                                                    <StyledCell>{item.reason}</StyledCell>
                                                    <StyledCell>{item.checkout_at}</StyledCell>
                                                </React.Fragment>
                                            ))
                                    ) : (
                                        <NoResult
                                            hideButton={false}
                                            style={{
                                                gridColumnStart: '1',
                                                gridColumnEnd: 'one',
                                            }}
                                        />
                                    )
                                ) : null}
                            </StyledTable>
                        </TableWrapper>
                    </Wrapper>
                </Col>
            </Row>
        </Grid>
    );
}
